import React from "react";
import styles from "./Table.module.scss";
import { BinIcon, PenIcon } from "../../../assets/icons";
import Loader from "../Loader/Loader";
import EmptyListIcon from "./EmptyListIcon/EmptyListIcon";
import TableHeaderCell from "./TableHeaderCell";

export interface TableRow {
  data: (string | number | React.ReactNode)[];
  id: string;
  onDelete?: () => void;
  onEdit?: () => void;


}
export type BodyRow = TableRow & {
  onRowClick?: () => void;
  onDeleteRow?: () => void;
  onEditRow?: () => void;
  variant?: Variant;
};

export type Variant = "default" | "dark";

export interface TableProps {
  headerTitle: string[];
  headerFilters?: (React.ReactNode | null)[];
  bodyData?: TableRow[];
  onRowClick?: (row: TableRow) => void;
  onDeleteRow?: (row: TableRow) => void;
  onEditRow?: (row: TableRow) => void;
  emptyMessage?: string;
  isLoading?: boolean;
  variant?: Variant;
  styleBody?: React.CSSProperties;
}
export default function Table({
  headerTitle,
  headerFilters,
  bodyData,
  onRowClick,
  onDeleteRow,
  onEditRow,
  isLoading,
  emptyMessage,
  variant = "default",
  styleBody,
}: TableProps) {
  const isEmpty = !bodyData || bodyData.length === 0

  return (
    <table  className={[styles["table"],styles["table--"+variant]].join(" ")}>
      <thead className={[styles["table-header"], styles["table-header--"+variant]].join(" ")}>
        <tr className={[styles["table-header-row"], styles["table-header-row--"+variant]].join(" ")}>
          {headerTitle.map((title, index) => (
            <th className={[styles["table-header-row__cell"], styles["table-header-row__cell--"+variant]].join(" ")} key={index}>
              <TableHeaderCell title={title} filter={headerFilters?.[index] ?? undefined} />
            </th>
          ))}
        </tr>
      </thead>
      <tbody style={styleBody} className={[styles["table-body"], styles["table-body--"+variant]].join(" ")}>
        {isLoading ? (
          <tr>
            <td colSpan={headerTitle.length} style={{ padding: 40 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Loader centered color={variant === 'dark' ? '#FFF' : ''}/>
              </div>
            </td>
          </tr>
        ) : isEmpty ? (
          <tr>
            <td colSpan={headerTitle.length} style={{ padding: 24 }}>
              <EmptyListIcon message={emptyMessage || "No Data"} color={variant === 'dark' ? '#fff' : undefined } />
            </td>
          </tr>
        ) : (
          bodyData?.map((row, index) => {
            const onDelete = row?.onDelete || onDeleteRow  ? () => {
              (row?.onDelete && row.onDelete()) ||
                (onDeleteRow && onDeleteRow(row));
            } : undefined;
            const onEdit = row?.onEdit || onEditRow? () => {
              (row?.onEdit && row.onEdit()) || (onEditRow && onEditRow(row));
            }: undefined;
            return (
              <Row
                key={index}
                {...row}
                onRowClick={() => onRowClick && onRowClick(row)}
                onDeleteRow={onDelete}
                onEditRow={onEdit}
                variant={variant}
              />
            );
          })
        )}
      </tbody>
    </table>
  );
}

export const Row = ({
  data,
  id,
  onRowClick,
  onDeleteRow,
  onEditRow,
  variant
}: BodyRow) => {
  return (
    <tr className={[styles["table-body-row"], styles["clickable"], styles["table-body-row--"+variant], styles["clickable--"+variant]].join(" ")}>
      {data.map((cell, index) => (
        <td
          className={[styles["table-body-row__cell"], styles["table-body-row__cell--"+variant]].join(" ")}
          key={index}
          onClick={onRowClick}
        >
          {cell}
        </td>
      ))}

        {(onDeleteRow || onEditRow) && (
      <td
      className={[
        styles["table-body-row__cell"],
        styles["table-body-row__cell--btn"],
        styles["table-body-row__cell--"+variant],
      ].join(" ")}
    >
        <ButtonAction onDeleteRow={onDeleteRow} onEditRow={onEditRow} color={variant === 'dark' ? 'white' : ''} variant={variant}/>
      </td>
        )}
    </tr>
  );
};

export const ButtonAction = ({
  onDeleteRow,
  onEditRow,
  color,
  variant = "default"
}: {
  onDeleteRow?: () => void;
  onEditRow?: () => void;
  variant?: Variant;
  color?: string;
}) => {
  return (
    <div className={styles["button-action-container"]}>
      {onEditRow && (
        <button
          className={[
            styles["button-action-container__button"],
            styles["button-action-container__button--edit"],
            styles["button-action-container__button--"+variant],
          ].join(" ")}
          onClick={onEditRow}
        >
          <PenIcon color={color || undefined} />
        </button>
      )}
      {onDeleteRow && (
        <button
          className={[
            styles["button-action-container__button"],
            styles["button-action-container__button--delete"],
            styles["button-action-container__button--"+variant],
          ].join(" ")}
          onClick={onDeleteRow}
        >
          <BinIcon color={color || undefined}  />
        </button>
      )}
    </div>
  );
};
